import axios from 'axios';
import { API_URL } from '../config';

// Base URL routing to backend NestJS proxy
const getBaseUrl = () => {
  if (API_URL) {
    const clean = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL;
    return `${clean}/careparrva-output`;
  }
  return '/careparrva-output';
};

const apiClient = axios.create();

apiClient.interceptors.request.use((config) => {
  config.baseURL = getBaseUrl();
  const crmToken = localStorage.getItem('authToken');
  if (crmToken) {
    config.headers.Authorization = `Bearer ${crmToken.trim()}`;
  }
  return config;
});

const careparrvaOutputService = {
  getBaseUrl,

  // 1. Auth Status & Re-authentication
  getAuthStatus: async () => {
    const res = await apiClient.get('/auth-status');
    return res.data;
  },

  authenticate: async (credentials) => {
    const res = await apiClient.post('/authenticate', credentials || {});
    return res.data;
  },

  // 2. Database Reports Management
  getReports: async (params = {}) => {
    const res = await apiClient.get('/reports', { params });
    return res.data;
  },

  getReportById: async (id) => {
    const res = await apiClient.get(`/reports/${id}`);
    return res.data;
  },

  // 3. Generate Output Report (S3 upload + DB save handled on backend)
  generateReport: async (reportConfig) => {
    const res = await apiClient.post('/generate', reportConfig);
    return res.data;
  },

  // 3.1 Get Live Tab Report (Direct from API without saving)
  getTabReport: async (payload) => {
    const res = await apiClient.post('/tab-report', payload);
    return res.data;
  },

  // 3.2 Save Report into database on user demand
  saveReport: async (reportPayload) => {
    const res = await apiClient.post('/save-report', reportPayload);
    return res.data;
  },

  // 4. Status Check / Sync
  getReportStatus: async (requestId) => {
    const res = await apiClient.get(`/status/${encodeURIComponent(requestId)}`);
    return res.data;
  },

  syncReportStatus: async (id) => {
    const res = await apiClient.post(`/sync-status/${id}`);
    return res.data;
  },

  syncAllPending: async () => {
    const res = await apiClient.post('/sync-all-pending');
    return res.data;
  },

  deleteReport: async (id) => {
    const res = await apiClient.delete(`/reports/${id}`);
    return res.data;
  },
};

export default careparrvaOutputService;
